import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Breadcrumb } from "antd";
import navigationConfig from "configs/NavigationConfig";
import IntlMessage from "components/util-components/IntlMessage";

let breadcrumbData = {
  "/app": <IntlMessage id="home" />,
};
navigationConfig.forEach((elm, i) => {
  const assignBreadcrumb = (obj) =>
    (breadcrumbData[obj.path] = <IntlMessage id={obj.title} />);
  if (elm.submenu) {
    elm.submenu.forEach((elm) => {
      assignBreadcrumb(elm);
      if (elm.submenu) {
        elm.submenu.forEach((elm) => {
          assignBreadcrumb(elm);
        });
      }
    });
  }
});

const BreadcrumbRoute = withRouter((props) => {
  const { location } = props;
  let breadCrumbItemsArr = [];
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const buildBreadcrumb = () =>
    pathSnippets.forEach((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
      if (breadcrumbData[url] !== undefined) {
        breadCrumbItemsArr.push(
          <Breadcrumb.Item key={url}>
            <Link to={url}>{breadcrumbData[url]}</Link>
          </Breadcrumb.Item>
        );
      }
    });
  buildBreadcrumb();
  return <Breadcrumb>{breadCrumbItemsArr}</Breadcrumb>;
});

export class AppBreadcrumb extends Component {
  render() {
    return <BreadcrumbRoute />;
  }
}

export default AppBreadcrumb;
